import { createContext, memo, PropsWithChildren } from 'react';
import { User } from './User';

export const defaultUser: User = {
    countryCode: null,
};

export type UserContext = {
    user: User;
    setUserCountryCode: (countryCode: string) => void;
};

const defaultUserContext: UserContext = {
    user: defaultUser,
    setUserCountryCode: () => {},
};

export const UserContext = createContext<UserContext>(defaultUserContext);

export const UserProvider: React.FC<PropsWithChildren<UserContext>> = memo(
    ({ children, ...value }) => (
        <UserContext.Provider value={value}>{children}</UserContext.Provider>
    ),
);

UserProvider.displayName = 'UserProvider';
